import { removeAllChildNodes } from "./removeAllChildNodes.js";

export function removeHTMLElemTree(elemID, removeSelf) {
  var elem = document.getElementById(elemID);
  if (elem) removeAllChildNodes(elem, removeSelf);
}
